import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function StaffDetails() {
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Staff Details</h1>
            <ul class="breadcrumb">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li> Staff Details</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
      {/* <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Staff Details</h1>
                        </div>
                        <div class="col-12 curr-blk">
                            <div class="staffboxsec">
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/principal.jpg" />
                                    </div>
                                    <div class="desc">
                                        <p> Fr.Dinu M Daniel <span> PRINCIPAL </span><span> B.Sc, B.Ed, M.Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ARTI RANI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Arti Rani <span> Teacher </span><span> I.A MONTESSORI T. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ANURADHA PATHAK.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Anuradha Pathak <span> Teacher </span><span> B.A. VOCAL, DANCE (B. MUSIC) </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ABANTI NANDY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Abanti Nandy <span> Teacher </span><span> B.Sc., B.Ed. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/SUCHITA DAS.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Suchita Das <span> Teacher </span><span> B.Sc., B.MUSIC </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/MAMTA TIWARY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Mamta Tiwary <span> Teacher </span><span> B.A., N.T.T., B.Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ANNU.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Annu <span> Teacher </span><span> B.A., N.T.T. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/POONAM JHA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Poonam Jha <span> Teacher </span><span> B.Sc., B.Ed., CTET </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/RAMA MANDAL.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Rama Mandal <span> Teacher </span><span> B.A. VOCAL, B.Sc. (PHYSICS) </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/KUMARI URVASHI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Ms. Kumari. Urvashi <span> Teacher </span><span> B.A.,(Hindi Hon.) B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/FARHEEN SADAF.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Farheen Sadaf <span> Teacher </span><span> B.A (SOCIOLOGY HONS.), B. Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/PRATIMA_KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Pratima Kumari <span> Teacher </span><span> B.Com, NTT </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/NITU KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Nitu Kumari <span> Teacher </span><span> M.A ., B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/DOLLY KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Dolly Kumari <span> Teacher </span><span> M.A. (ENGLISH), B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/GITA KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Gita Kumari <span> Teaching Staff </span><span> M.A., DLED, CTET PAPER I &amp; II
                                        </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/MAYA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Maya <span> Teacher </span><span> M.A. (HISTORY), B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/RASHMI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Rashmi <span> Teacher </span><span> B.Sc (Zoology (Hns.), B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/PREETI SHARMA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Preeti Sharma <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ANSHU KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Anshu Kumari <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/NEETU RANI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Neetu Rani <span> Teacher </span><span> B.P. Ed. </span></p>
                                    </div>
                                </div>




                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/REENA KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Reena Kumari <span> Teacher </span><span> B.A., N.T.T. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/KOMAL.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Komal <span> Teacher </span><span> M.B.A (HR), NTT - 1 YR. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/ANKITA GUPTA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Ankita Gupta <span> Teacher </span><span> B.B.A (Pursuing), N.T.T - 1 YRS. </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/MEHAJABIN PARVEEN.JPG " />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Mehjabin Parveen <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/SOBHY THOMAS.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Sobhy Thomas <span> Office Assistant </span><span> P.D.C., Stenography &amp;
                                            Computer (D.C.A) </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/PARVATI KERKETTA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Parvati Kerketta <span> Ayah </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/MANOJ KUMAR NAPIT.jpeg" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Manoj Kumar Napit <span> Watchman </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/TRIBENI KR. MAHATHA.jpeg" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Tribeni Kr. Mahatha <span> Watchman </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/SAGAR GOPE.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Sagar Gope <span> Maali </span>
                                            <span> Non-Matriculate </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/LUCY TIRKEY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Lucy Tirkey <span> Ayah </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
      <section className="innerBody">
        <div className="container them-container">
          <div className="row">
            <div className="col-12">
              <h1>Staff Details</h1>
            </div>
            <div class="col-12 curr-blk">
              <div class="staffboxsec">
                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block "
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/principal-new.jpeg"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      {" "}
                      Fr.Dinu M Daniel <span> PRINCIPAL </span>
                      <span>Teaching Staff</span>
                      <span>B.Sc, B.D, GST, M.A. , M.Ed</span>
                    </p>
                  </div>
                </div>
                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/mamta-new.jpeg"
                      alt="Mamta Tiwary"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Mamta Tiwary
                      <span>ACADEMIC COORDINATOR</span>
                      <span>Teaching Staff</span>
                      <span>B.A, N.T.T., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/pratima-new.jpeg"
                      alt="Pratima Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Pratima Kumari
                      <span>
                        CLASS COORDINATOR &amp; ASSESSMENT COORDINATOR
                      </span>
                      <span>Teaching Staff</span>
                      <span>B.Com, N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/preeti-new.jpg"
                      alt="Preeti Sharma"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Preeti Sharma
                      <span>CLASS COORDINATOR</span>
                      <span>Teaching Staff</span>
                      <span>M.A., B.Ed., N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Dolly-new.jpeg"
                      alt="Dolly Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Dolly Kumari
                      <span>CLASS COORDINATOR</span>
                      <span>Teaching Staff</span>
                      <span>M.A. (English), B.Ed., N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Anshu-new.jpeg"
                      alt="Anshu Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Anshu Kumari
                      <span>CULTURAL COORDINATOR &amp; SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>M.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Rama-new.jpeg"
                      alt="Rama Mandal"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Rama Mandal
                      <span>PRO &amp; SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., B.Sc.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Farheen-new.jpeg"
                      alt="Farheen Sadaf"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Farheen Sadaf
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A. (Sociology Hons.), B.Ed., N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Anushka-new.jpeg"
                      alt="Anushka Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Anushka Kumari
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>BBA, N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Kashish-new.jpeg"
                      alt="Kashish Anjum"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Kashish Anjum
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Nisha-new.jpg"
                      alt="Nisha Kumari Singh"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Nisha Kumari Singh
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., M.A.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Deepali-new.jpg"
                      alt="Deepali"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Deepali
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>BBA, MBA</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Maya-new.jpeg"
                      alt="Maya"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Maya
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>M.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Annu-new.jpeg"
                      alt="Annu"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Annu
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., N.T.T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Vineeta-new.jpeg"
                      alt="Vineeta Das"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Vineeta Das
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Namrata-new.jpeg"
                      alt="Namrata"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Namrata
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>BBA</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Stuti-new.jpeg"
                      alt="Stuti Sarah Lall"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Stuti Sarah Lall
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Aishwarya-new.jpeg"
                      alt="Aishwarya"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Aishwarya
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., D.EL.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Ahalya-new.jpeg"
                      alt="Ahalya Swain"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Ahalya Swain
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.Sc.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Baisakhi-new.jpg"
                      alt="Baisakhi Mukhopadhyay"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Baisakhi Mukhopadhyay
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>MCA</span>
                    </p>
                  </div>
                </div>
                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Mamta-rani-new.jpeg"
                      alt="Mamta Rani"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Mamta Rani
                      <span>CLASS TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.Com, D.EL.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Arti-new.jpg"
                      alt="Arti Rani"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Arti Rani
                      <span>SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>IA Montessori T.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Kumari-new.JPG"
                      alt="Kumari Urvashi"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Kumari Urvashi
                      <span>SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Neetu-new.jpg"
                      alt="Neetu Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Neetu Kumari
                      <span>SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>M.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Veena-new.jpeg"
                      alt="Veena"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Veena
                      <span>SUBJECT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>M.A., B.Ed., Diploma in Classical Music</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Nitu-new.jpeg"
                      alt="Nitu Rani"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Nitu Rani
                      <span>PT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.P.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Suhana-new.jpeg"
                      alt="Suhana Hyat"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Suhana Hyat
                      <span>ASSISTANT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>ECCE</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Khushboo-new.jpeg"
                      alt="Khushboo Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Khushboo Kumari
                      <span>ASSISTANT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Divya-new.jpeg"
                      alt="Divya Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Divya Kumari
                      <span>ASSISTANT TEACHER</span>
                      <span>Teaching Staff</span>
                      <span>B.A., B.Ed.</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Sobhy-new.jpeg"
                      alt="Sobhy Thomas"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Sobhy Thomas
                      <span>OFFICE ASSISTANT</span>
                      <span>Non Teaching Staff</span>
                      <span>P.D.C., Stenography, DCA</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Ruchi-new.jpeg"
                      alt="Ruchi Kumari"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Ms. Ruchi Kumari
                      <span>OFFICE ASSISTANT</span>
                      <span>Non Teaching Staff</span>
                      <span>B.Com, Diploma (HTCS)</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Manoj-new.jpeg"
                      alt="Manoj Kumar Napit"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Manoj Kumar Napit
                      <span>WATCHMAN</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Tribeni-new.jpeg"
                      alt="Tribeni Kr. Mahatha"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Tribeni Kr. Mahatha
                      <span>WATCHMAN</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Satyanarayan-new.JPG"
                      alt="Satyanarayan Pramanik"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Satyanarayan Pramanik
                      <span>WATCHMAN</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Santosh-new.JPG"
                      alt="Santosh Kumar Mahto"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Santosh Kumar Mahto
                      <span>WATCHMAN</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>
                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Arjun-new.JPG"
                      alt="Arjun Mahto"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Arjun Mahto
                      <span>WATCHMAN</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Parvati-new.png"
                      alt="Parvati Kerketta"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mrs. Parvati Kerketta
                      <span>AYAH</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Lucy-new.png"
                      alt="Lucy Tirkey"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mrs. Lucy Tirkey
                      <span>AYAH</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Sima-new.JPG"
                      alt="Sima Gorain"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mrs. Sima Gorain
                      <span>AYAH</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Kumari-new.JPG"
                      alt="Kumari Devi"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mrs. Kumari Devi
                      <span>AYAH</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Gayatri-new.JPG"
                      alt="Gayatri Kerketta"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mrs. Gayatri Kerketta
                      <span>AYAH</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>

                <div class="staffbox">
                  <div class="imgbox">
                    <img
                      class="img-fluid mx-auto d-block"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/Sagar-new.png"
                      alt="Sagar Gope"
                    />
                  </div>
                  <div class="desc">
                    <p>
                      Mr. Sagar Gope
                      <span>MALI</span>
                      <span>Supporting Staff</span>
                      <span>Non-Matriculate</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  );
}

export default StaffDetails;
